module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"toOrderSheet":"Zum Ordersatz"},"en":{"toOrderSheet":"Open order sheet"}}')
  delete Component.options._Ctor
}
